import React from "react";
import { getPassengerTimetables, timetablePdfPath } from "../data/passengerTimetables";
import { ReactComponent as Download } from "../assets/icons/Download.svg";

export default function PassengerTimetables({ operatorId }) {
    const data = getPassengerTimetables(operatorId);
    if (!data) {
        return null;
    }

    return (
        <div className="PassengerTimetables">
            <div className="PassengerTimetablesIntro">{data.intro}</div>
            <ul className="CardList">
                {data.routes.map((route) => {
                    const pdfPath = timetablePdfPath(route.routeUrl);
                    return (
                        <li key={route.number}>
                            <a
                                className="CardListRoute"
                                href={route.routeUrl}
                                target="_blank"
                                rel="noreferrer"
                            >
                                Route <strong>{route.number}</strong> {route.name}
                            </a>
                            {pdfPath && (
                                <a
                                    className="CardListPdf"
                                    href={pdfPath}
                                    target="_blank"
                                    rel="noreferrer"
                                    aria-label={`Download route ${route.number} timetable (PDF)`}
                                >
                                    <Download /> PDF
                                </a>
                            )}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}
